/**
 * Belo Accordion Functionality
 * 
 * This JavaScript file handles the accordion functionality for the FAQ section
 * and any other accordion elements on the page.
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get all accordion headers
  const accordionHeaders = document.querySelectorAll('.accordion-header');
  
  // Add click event listener to each header
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      // Toggle active class on the header
      this.classList.toggle('active');
      
      // Get the content element
      const content = this.nextElementSibling;
      
      // Toggle active class on the content
      content.classList.toggle('active');
    });
  });
});
